import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import Label from '../../components/atoms/display/Label'
import { FlexColumn, FlexRow } from '../../components/atoms/layout/Flex'
import ClientBasicView from '../../components/organisms/client/ClientBasicView'
import ClientWorkView from '../../components/organisms/client/ClientWorkView'
import ClientEvaluationView from '../../components/organisms/client/ClientEvaluationView'
import ClientMoneyspaceTable from '../../components/organisms/client/ClientMoneyspaceTable'
import ClientBankAccountView from '../../components/organisms/client/ClientBankAccountView'
import usePage from '../../hooks/usePage'
import Link from '../../components/atoms/navigation/Link'
import { BackIcon } from '../../components/atoms/display/Icons'
import usePath from '../../hooks/usePath'
import SectionPanel from '../../components/molecules/SectionPanel'
import { CompanySelectors } from '../../store/company/selectors'
import { CompanyActions } from '../../store/company'
import CircularProgress from '../../components/atoms/feedback/CircularProgress'
import { MoneyspacesSelectors } from '../../store/moneyspaces/selectors'

export default function ClientDetailPage() {
  const { changeTitle } = usePage()
  const { settingsClientsSearch } = usePath()
  const clientDetails = useSelector(CompanySelectors.clientDetails)
  const dispatch = useDispatch()
  const { companyId } = useParams()
  const moneyspaces = useSelector(MoneyspacesSelectors.moneyspaces)

  useEffect(() => {
    changeTitle('取引先詳細')
  }, [changeTitle])

  useEffect(() => {
    dispatch(CompanyActions.fetchClientDetails())
  }, [dispatch])

  const clientDetail = clientDetails?.find((detail) => detail.id === companyId)

  if (!clientDetail) {
    return (
      <FlexRow align="center" justify="center" pa={4}>
        <CircularProgress size="normal" />
      </FlexRow>
    )
  }

  return (
    <FlexColumn>
      <Link href={settingsClientsSearch()}>
        <FlexRow>
          <BackIcon size={16} />
          <Label text="取引先詳細検索" variant="caption" />
        </FlexRow>
      </Link>
      <Label text={clientDetail.name} variant="title" />
      <FlexRow wrap>
        <FlexColumn width="640px">
          {clientDetail.moneyspaceIds.length > 0 && (
            <FlexColumn space={0}>
              <Label text="マネースペース" variant="subtitle" />
              <ClientMoneyspaceTable
                moneyspaces={moneyspaces.filter((moneyspace) => clientDetail.moneyspaceIds.includes(moneyspace.id))}
              />
            </FlexColumn>
          )}
          <SectionPanel title="基本情報" size="full">
            <ClientBasicView clientDetail={clientDetail} />
          </SectionPanel>
          <SectionPanel title="工事情報" size="full">
            <ClientWorkView clientDetail={clientDetail} />
          </SectionPanel>
          <SectionPanel title="口座情報" size="full">
            <ClientBankAccountView clientDetail={clientDetail} />
          </SectionPanel>
        </FlexColumn>
        <FlexColumn width="480px">
          <Label text="評価" variant="subtitle" />
          <ClientEvaluationView clientDetail={clientDetail} />
        </FlexColumn>
      </FlexRow>
    </FlexColumn>
  )
}
